import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Card, Row, Col, Table } from 'react-bootstrap';
import { FiBarChart2, FiTrendingUp, FiAlertTriangle } from 'react-icons/fi';
import { fetchClaimsTrips, fetchClaimsActivities } from '../store/actions/dataActions';
import 'bootstrap/dist/css/bootstrap.css';
import './DashboardPages.css';

const Claims = () => {
    const dispatch = useDispatch();
    const { claims } = useSelector(state => state.data);

    useEffect(() => {
        dispatch(fetchClaimsTrips());
        dispatch(fetchClaimsActivities());
    }, [dispatch]);

    const calculateClaimsStats = () => {
        const allClaims = [
            ...(claims.trips.data || []),
            ...(claims.activities.data || []),
        ];

        const totalClaimsAmount = allClaims.reduce((sum, claim) => {
            return sum + (claim.claim_amount || claim.amount || 0);
        }, 0);

        const numberOfClaims = allClaims.length;

        const pendingClaims = allClaims.filter(claim =>
            claim.status === 'pending' || claim.status === 'pending'
        ).length;

        return {
            totalClaimsAmount: totalClaimsAmount.toFixed(2),
            numberOfClaims,
            pendingClaims,
        };
    };

    const stats = calculateClaimsStats();
    const loading = claims.trips.loading || claims.activities.loading;

    return (
        <div className="dashboard-page">
            <h2 className="page-header">Claims</h2>
            <Row className="mb-4">
                <Col md={4}>
                    <Card className="stat-card stat-danger">
                        <Card.Body>
                            <div className="stat-content">
                                <FiBarChart2 className="stat-icon" />
                                <div>
                                    <div className="stat-value">
                                        {loading ? '...' : `${stats.totalClaimsAmount} €`}
                                    </div>
                                    <div className="stat-label">Total claims amount</div>
                                </div>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
                <Col md={4}>
                    <Card className="stat-card stat-danger">
                        <Card.Body>
                            <div className="stat-content">
                                <FiAlertTriangle className="stat-icon" />
                                <div>
                                    <div className="stat-value">
                                        {loading ? '...' : stats.numberOfClaims}
                                    </div>
                                    <div className="stat-label">Total number of claims</div>
                                </div>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
                <Col md={4}>
                    <Card className="stat-card stat-warning">
                        <Card.Body>
                            <div className="stat-content">
                                <FiTrendingUp className="stat-icon" />
                                <div>
                                    <div className="stat-value">
                                        {loading ? '...' : stats.pendingClaims}
                                    </div>
                                    <div className="stat-label">Pending claims</div>
                                </div>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>

            <Card className="mt-4" style={{ backgroundColor: '#4C566A', border: 'none' }}>
                <Card.Header style={{ backgroundColor: '#21388B', color: '#ECEFF4' }}>
                    <h5 className="mb-0">Claims Details</h5>
                </Card.Header>
                <Card.Body>
                    {loading ? (
                        <div className="text-center">Chargement...</div>
                    ) : (
                        <Table striped bordered hover variant="dark" responsive>
                            <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>Type</th>
                                    <th>Amount</th>
                                    <th>Status</th>
                                    <th>Date</th>
                                </tr>
                            </thead>
                            <tbody>
                                {[
                                    ...(claims.trips.data || []),
                                    ...(claims.activities.data || []),
                                ].slice(0, 10).map((claim, index) => (
                                    <tr key={index}>
                                        <td>{claim.id || claim.claim_id || '-'}</td>
                                        <td>{claim.type || claim.claim_type || '-'}</td>
                                        <td>{claim.claim_amount || claim.amount || 0} €</td>
                                        <td>{claim.status || 'N/A'}</td>
                                        <td>{claim.date || claim.claim_date || '-'}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    )}
                </Card.Body>
            </Card>
        </div>
    );
};

export default Claims;

